module.exports = __webpack_public_path__ + "static/media/2.0d776558.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/2.wav
// module id = 31
// module chunks = 0